import { render, staticRenderFns } from "./ccLives.vue?vue&type=template&id=6479e1a5&scoped=true"
import script from "./ccLives.vue?vue&type=script&lang=js"
export * from "./ccLives.vue?vue&type=script&lang=js"
import style0 from "./ccLives.vue?vue&type=style&index=0&id=6479e1a5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6479e1a5",
  null
  
)

export default component.exports